package br.com.heyagenda.domain.util

import kotlin.random.Random

object SlugUtils {

    fun toSlug(input: String): String {
        val normalized = input.lowercase()
            .replace(Regex("[áàâãä]"), "a")
            .replace(Regex("[éèêë]"), "e")
            .replace(Regex("[íìîï]"), "i")
            .replace(Regex("[óòôõö]"), "o")
            .replace(Regex("[úùûü]"), "u")
            .replace(Regex("[ç]"), "c")
            .replace(Regex("[^a-z0-9]"), "-")
            .replace(Regex("-+"), "-")
            .trim('-')
        return if (normalized.isBlank()) "agenda" else normalized
    }

    fun appendRandomSuffix(baseSlug: String): String {
        val rand = Random.nextInt(100, 999)
        return "$baseSlug-$rand"
    }
}
